export default __webpack_public_path__ + "static/media/jp3.2145af94.jpg";